import React from 'react';

function Footer() {
    return (
        <React.Fragment>
            <div className="d-none d-md-block footer mt-5">
                <div className="col-12 pt-3">
                    <div className="text-center">
                        <a 
                            href='mailto:info@eclipsereality.com'
                            className='btn btn-lime'
                        >Email Us</a>
                    </div>
                </div>
                <div className="col-12 text-center footer-links">
                    <a href="https://www.eclipsereality.com/trust/" title="Security Statement">Security Statement</a> |
                    <a href="https://www.eclipsereality.com/contact-us/" title="Privacy Policy">Cookies and Privacy Policy</a> |
                    <a href="https://www.eclipsereality.com/terms/" title="Terms of Service">Terms of Service</a>
                </div>
                <div className="col-12 text-center footer-links">
                    <span>© 2023 Eclipse Worlds, LLC. All rights reserved.</span>
                </div>
            </div>

        </React.Fragment>
    );
}



export default Footer;
